<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Table of Contents</h2>
<p class="firstcenter"><a href="#/Text/preface#toc">Preface</a></p>
<table>
<tbody><tr>
<th colspan="5">Index to first letter</th>
</tr>
<tr>
<th><a href="#/Text/A2L#Letter_A"><span class="initial-cap">A</span></a></th>
<th><a href="#/Text/A2L#Letter_B"><span class="initial-cap">B</span></a></th>
<th><a href="#/Text/A2L#Letter_C"><span class="initial-cap">C</span></a></th>
<th><a href="#/Text/A2L#Letter_D"><span class="initial-cap">D</span></a></th>
<th><a href="#/Text/A2L#Letter_E"><span class="initial-cap">E</span></a></th>
</tr>
<tr>
<th><a href="#/Text/A2L#Letter_F"><span class="initial-cap">F</span></a></th>
<th><a href="#/Text/A2L#Letter_G"><span class="initial-cap">G</span></a></th>
<th><a href="#/Text/A2L#Letter_H"><span class="initial-cap">H</span></a></th>
<th><a href="#/Text/A2L#Letter_I"><span class="initial-cap">I</span></a></th>
<th><a href="#/Text/A2L#Letter_J"><span class="initial-cap">J</span></a></th>
</tr>
<tr>
<th><a href="#/Text/A2L#Letter_K"><span class="initial-cap">K</span></a></th>
<th><a href="#/Text/A2L#Letter_L"><span class="initial-cap">L</span></a></th>
<th><span href="#/Text/M2Z#Letter_M" title="Link target outside of Sample"><span class="initial-cap">M</span></span></th>
<th><span href="#/Text/M2Z#Letter_N" title="Link target outside of Sample"><span class="initial-cap">N</span></span></th>
<th><span href="#/Text/M2Z#Letter_O" title="Link target outside of Sample"><span class="initial-cap">O</span></span></th>
</tr>
<tr>
<th><span href="#/Text/M2Z#Letter_P" title="Link target outside of Sample"><span class="initial-cap">P</span></span></th>
<th><span class="initial-cap">Q</span></th>
<th><span href="#/Text/M2Z#Letter_R" title="Link target outside of Sample"><span class="initial-cap">R</span></span></th>
<th><span href="#/Text/M2Z#Letter_S" title="Link target outside of Sample"><span class="initial-cap">S</span></span></th>
<th><span href="#/Text/M2Z#Letter_T" title="Link target outside of Sample"><span class="initial-cap">T</span></span></th>
</tr>
<tr>
<th><span href="#/Text/M2Z#Letter_U" title="Link target outside of Sample"><span class="initial-cap">U</span></span></th>
<th><span href="#/Text/M2Z#Letter_V" title="Link target outside of Sample"><span class="initial-cap">V</span></span></th>
<th><span href="#/Text/M2Z#Letter_W" title="Link target outside of Sample"><span class="initial-cap">W</span></span></th>
<th colspan="2"><span href="#/Text/M2Z#Letter_Z" title="Link target outside of Sample"><span class="initial-cap">XYZ</span></span></th>
</tr>
</tbody></table>
<p class="firstcenter"><span href="#/Text/series" title="Link target outside of Sample">Pocket Reference Collection from IVP Academic</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6a31e27d